export const DetailConf = {
  initialState: {
    loading: false,
    error: null,
    data: null,
    meta: null,
  },
  fields: [
    {
      items: [
        {
          type: 'text',
          label: 'Location',
          key: 'attributes.location',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Code',
          key: 'attributes.code',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Marina',
          key: 'attributes.marina',
          xs: 12,
          sm: 6,
        },
        {
          type: 'text',
          label: 'Area',
          key: 'attributes.area',
          xs: 12,
          sm: 6,
        },
      ],
    },
  ],
  formatValue: (key, value) => {
    switch (key) {
      default:
        return null;
    }
  },
};
